const onPaidPlans = 'доступно на тарифах «Стандарт» и «Премиум»'

/** Canonical paywall copy aligned with epic §6 and core PlanBillingMessages. */
export const paywallCopy = {
  marketAndRfq: `Доступ к рынку и заявкам поставщикам ${onPaidPlans}.`,
  platformRfq: `Заявки поставщикам на платформе ${onPaidPlans}.`,
  platformChat: `Чат по платформенным сделкам ${onPaidPlans}.`,
  buyerSuppliers: `Список платформенных поставщиков ${onPaidPlans}.`,
  marketPriceIntelligence: 'Динамика цен доступна на тарифе «Премиум».',
  seatLimitStart: 'Действие временно недоступно.',
  seatLimitStandard: 'Действие временно недоступно.',
  deviceLimit:
    'На вашем тарифе разрешено одно устройство для аккаунта. Выйдите на другом устройстве или обновите тариф до «Премиум».',
  myPricesSupplierLimit:
    'На тарифе «Старт» можно вести прайсы до 5 поставщиков. Обновите тариф до «Стандарт» или «Премиум».',
  venueLimitStartStandard: 'Подключение нескольких заведений доступно на тарифе «Премиум».',
  venueAddonRequired: 'В «Премиум» входят 3 заведения. Подключите следующее (+3 000 ₽/мес).',
  ownerOnly: 'Этот раздел доступен только владельцу аккаунта.',
} as const

export const myPricesRefreshCooldownMessage = (nextAvailableAt?: string): string => {
  const dateLabel = nextAvailableAt?.trim() || 'позже'
  return `На «Старте» прайс поставщика можно обновлять не чаще одного раза в неделю. Следующее обновление: ${dateLabel}. Обновите тариф до «Стандарт» или «Премиум», чтобы снять ограничение.`
}

export const seatLimitFallbackMessage = (currentPlan?: string): string => {
  if (currentPlan === 'standard') {
    return paywallCopy.seatLimitStandard
  }
  if (currentPlan === 'start') {
    return paywallCopy.seatLimitStart
  }
  return 'Действие временно недоступно.'
}

export const billingFeatureFallbackMessage = (_requiredPlanDisplayName?: string): string =>
  'Действие недоступно. Обновите тариф до «Стандарт» или «Премиум».'

export const deviceTakeoverCopy = {
  title: 'Вы уже вошли на другом устройстве',
  primary: 'Войти здесь',
  dismiss: 'Отмена',
} as const

/** Текст промпта «войти здесь» с данными активного устройства (если пришли из API). */
export const deviceTakeoverMessage = (activeDeviceLabel?: string, lastSeenText?: string): string => {
  const device = activeDeviceLabel?.trim()
  const seen = lastSeenText?.trim()
  const where = device
    ? `Сейчас активно устройство «${device}»${seen ? ` (последний вход: ${seen})` : ''}.`
    : 'Сейчас активна сессия на другом устройстве.'
  return `На вашем тарифе доступно одно устройство. ${where} Войти здесь? На другом устройстве произойдёт выход.`
}
